import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface OpcaoSegmentada {
  valor: any;
  label: string;
  icone?: string;
}

@Component({
  selector: 'app-campo-segmentado',
  standalone: true,
  imports: [],
  templateUrl: './campo-segmentado.component.html',
  styleUrl: './campo-segmentado.component.css',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CampoSegmentadoComponent), multi: true }
  ]
})
export class CampoSegmentadoComponent implements ControlValueAccessor {
  @Input() opcoes: OpcaoSegmentada[] = [];
  @Input() disabled = false;
  @Input() somenteLeitura = false;

  get opcaoAtual(): OpcaoSegmentada | undefined {
    return this.opcoes.find(o => o.valor === this.valor);
  }

  get temIcones(): boolean {
    return this.opcoes.some(o => !!o.icone);
  }

  valor: any;

  private onChange: (value: any) => void = () => { /* */ };
  private onTouched: () => void = () => { /**/ };

  writeValue(value: any): void {
    this.valor = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  selecionar(opcao: OpcaoSegmentada) {
    if (this.disabled) {
      return;
    }
    this.valor = opcao.valor;
    this.onChange(opcao.valor);
    this.onTouched();
  }

  get totalOpcoes(): number {
    return Math.max(this.opcoes.length, 1);
  }

  get indiceAtivo(): number {
    const indice = this.opcoes.findIndex(o => o.valor === this.valor);
    return indice < 0 ? 0 : indice;
  }
}
